import { render, staticRenderFns } from "./SmsDistribution.vue?vue&type=template&id=65f8bac8&"
import script from "./SmsDistribution.vue?vue&type=script&lang=ts&"
export * from "./SmsDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports